// Client side counterpart of the backend SettingDefinition::validate(). The backend validates again.

// Returns [translation key, params] of the first error, or null if the value is valid.
export function validateSetting(definition, value) {
  const c = definition.constraints || {};
  switch (definition.type) {
    case "bool":
      return typeof value === "boolean" ? null : ["satellites.settings.errors.type"];
    case "int":
      if (!Number.isInteger(value)) return ["satellites.settings.errors.int"];
      if ((c.min !== undefined && value < c.min) || (c.max !== undefined && value > c.max)) {
        return ["satellites.settings.errors.range", { min: c.min, max: c.max }];
      }
      return null;
    case "enum":
      return (c.choices || []).includes(value) ? null : ["satellites.settings.errors.choice"];
    case "string":
      return validateString(c, value);
    case "string_list":
      if (!Array.isArray(value)) return ["satellites.settings.errors.type"];
      if (c.max_items !== undefined && value.length > c.max_items) {
        return ["satellites.settings.errors.max_items", { number: c.max_items }];
      }
      for (const item of value) {
        const error = validateString(c, item);
        if (error) return error;
      }
      return null;
    default:
      return null;
  }
}

function validateString(c, value) {
  if (typeof value !== "string") return ["satellites.settings.errors.type"];
  if (c.max_length !== undefined && value.length > c.max_length) {
    return ["satellites.settings.errors.max_length", { number: c.max_length }];
  }
  if (c.pattern && !toRegExp(c.pattern).test(value)) return ["satellites.settings.errors.pattern"];
  return null;
}

// Converts a PHP PCRE literal like "/^[a-z]+$/i" to a RegExp.
function toRegExp(pattern) {
  const match = /^(.)(.*)\1([a-z]*)$/s.exec(pattern);
  try {
    return match ? new RegExp(match[2], match[3].replace(/[^gimsuy]/g, "")) : new RegExp(pattern);
  } catch (e) {
    return { test: () => true };
  }
}

export function settingLabel(vm, key) {
  const path = `satellites.settings.keys.${key}.label`;
  return vm.$te(path) ? vm.$t(path) : key;
}

export function settingHint(vm, key) {
  const path = `satellites.settings.keys.${key}.hint`;
  return vm.$te(path) ? vm.$t(path) : "";
}

export function formatSettingValue(vm, value) {
  if (typeof value === "boolean") return vm.$t(value ? "satellites.settings.on" : "satellites.settings.off");
  if (Array.isArray(value)) return value.length ? value.join(", ") : "—";
  if (value === "" || value === null || value === undefined) return "—";
  return String(value);
}

// Settings that differ from the defaults: { key: value } → [{ key, label, value }] for summaries.
export function changedSettings(vm, definitions, values) {
  return definitions
    .filter((definition) => values && definition.key in values && JSON.stringify(values[definition.key]) !== JSON.stringify(definition.default))
    .map((definition) => ({ key: definition.key, label: settingLabel(vm, definition.key), value: formatSettingValue(vm, values[definition.key]) }));
}
